






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TramiteCambioDireccion from "@/models/tramite/cambio-direccion/cambio-direccion.model";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import Hogar from "@/models/hogar/hogar.model";
import Direccion from "@/models/direccion.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TipoTramite from "@/models/tipoTramite";

@Component
export default class CambioDireccionResumen extends BaseVue {
  @Prop() readonly id!: number;
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;

  direccionId = 0;
  get personaId() {
    if (this.beneficiario && this.beneficiario.personaId)
      return this.beneficiario.personaId;

    if (this.solicitante && this.solicitante.id) return this.solicitante.id;

    return 0;
  }

  get tramiteBeneficiarioId() {
    if (this.id) return this.id;
    if (this.content && this.content.id) return this.content.id;
    if (this.$route.params.id) return this.$route.params.id;
    return 0;
  }

  async mounted() {
    if (this.tramiteBeneficiarioId) {
      this.direccionId = await new BaseHttpClient(
        "TramiteBeneficiarioResumen"
      ).getAsync("GetTramiteDireccionId", {
        tramiteId: this.tramiteBeneficiarioId
      });
    }
  }
}
